document.addEventListener('DOMContentLoaded', function() {
  // スマホ用目次の制御
  const tocButton = document.getElementById('toc-sp-button')
  const tocContent = document.getElementById('toc-sp-content')
  const tocClose = document.getElementById('toc-sp-close')
  const tocSlidePanel = tocContent?.querySelector('.transform')

  if (tocButton && tocContent && tocClose && tocSlidePanel) {
    // 目次を開く
    tocButton.addEventListener('click', () => {
      tocContent.classList.remove('hidden')
      // ちょっと遅延させてアニメーションが見えるようにする
      setTimeout(() => {
        tocSlidePanel.classList.remove('translate-y-full')
      }, 10)
    })

    // 目次を閉じる
    const closeToc = () => {
      tocSlidePanel.classList.add('translate-y-full')
      // アニメーション完了後に非表示
      setTimeout(() => {
        tocContent.classList.add('hidden')
      }, 300)
    }

    // 閉じるボタンクリック
    tocClose.addEventListener('click', closeToc)

    // オーバーレイクリック
    tocContent.addEventListener('click', e => {
      if (e.target === tocContent) {
        closeToc()
      }
    })

    // 目次リンククリック
    tocContent.querySelectorAll('.toc-link').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault()
        const targetId = e.target.getAttribute('href')
        const targetElement = document.querySelector(targetId)

        if (targetElement) {
          closeToc()
          // 目次が閉じるのを待ってからスクロール
          setTimeout(() => {
            const headerOffset = 100
            const elementPosition = targetElement.getBoundingClientRect().top
            const offsetPosition =
              elementPosition + window.pageYOffset - headerOffset

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            })
          }, 300)
        }
      })
    })
  }

  // PC用目次のスムーズスクロール
  const tocPc = document.querySelector('.toc-pc')
  if (tocPc) {
    tocPc.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault()
        const targetId = e.target.getAttribute('href')
        const targetElement = document.querySelector(targetId)

        if (targetElement) {
          const headerOffset = 100
          const elementPosition = targetElement.getBoundingClientRect().top
          const offsetPosition =
            elementPosition + window.pageYOffset - headerOffset

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          })
        }
      })
    })
  }

  // 動的に追加された場合に備えて、定期的に初期化を試みる
  const initInterval = setInterval(() => {
    const tocSpTrigger = document.getElementById('toc-sp-trigger')
    const tocPc = document.querySelector('.toc-pc')

    if (tocSpTrigger || tocPc) {
      // 既に初期化済みの場合は何もしない
      clearInterval(initInterval)
    }
  }, 1000)
})
